import * as constants from './constants'

export const sendGoogleReserveConversionData = currentLocationId => ({
    type: constants.SEND_GOOGLE_RESERVE_CONVERSION_DATA,
    currentLocationId,
})
